



























import { Component, Vue, Prop } from 'vue-property-decorator';
import { performanceServer } from '@/api/installServer';

@Component({
  components: {},
})
export default class DelayDialog extends Vue {
  private visible = false;
  private title = '隐患延期';

  private formData: any = {
    extensionDeadline: '',
    delayReason: '',
    hazardId: '',
  };

  private extensionDeadline: any = '';
  private delayStatus: any = 0;
  private rectifyExpiryDate: any = '';
  private formDataRule: any = {
    extensionDeadline: [{ required: true, message: '请选择延期截止时间', trigger: 'blur' }],
    delayReason: [{ required: true, message: '请输入延期原因', trigger: 'change' }],
  };
  pickerOptions: any = {
    // 限制日期
    disabledDate: this.disabledDate,
  };
  private disabledDate(time: any) {
    return time.getTime() < new Date(this.getDelayDateRange()).getTime() - 8.64e7;
  }

  private getDelayDateRange() {
    if (this.delayStatus === 2) {
      if (this.rectifyExpiryDate < this.extensionDeadline) {
        return this.extensionDeadline;
      } else {
        return this.rectifyExpiryDate;
      }
    } else {
      return this.rectifyExpiryDate;
    }
  }

  showDialog(data: any) {
    this.formData.hazardId = data.id;
    this.delayStatus = data.delayStatus;
    this.extensionDeadline = data.extensionDeadline;
    this.rectifyExpiryDate = data.rectifyExpiryDate;
    this.visible = true;
  }

  submitForm() {
    //表单验证
    const formComponent: any = this.$refs['form'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      performanceServer.delayHazard(this.formData).then((res: any) => {
        if (res.code === '200') {
          this.$message.success('延期成功！');
          this.hideDialog();
        } else {
          this.$message.warning(res.msg);
        }
      });
    });
  }
  hideDialog() {
    this.visible = false;
    this.formData = {};
    this.$nextTick(() => {
      (this.$refs.form as any).clearValidate();
    });
    this.$emit('delayDialogRes');
  }
  mounted() {}
}
